define.alias("ember-composable-helpers/helpers/range", "settings/helpers/range");